import { useEffect, useState } from "react";
import { useApi } from "@/lib/api";

// Leads per source and campaign in the last 90 days: real and test/simulated always counted apart.
export function LeadStats({ tid, tick }) {
  const api = useApi();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/t/${tid}/lead-sources/stats`).then(({ data }) => setD(data)).catch(() => setD(null)); }, [api, tid, tick]);
  if (!d?.rows?.length) return null;
  return (
    <section className="rounded-lg border border-slate-200 bg-white p-4" data-testid="lead-stats">
      <p className="mb-2 text-sm font-medium text-slate-800">Lead per fonte e campagna (ultimi {d.days} giorni)</p>
      <div className="overflow-x-auto"><table className="w-full text-xs sm:min-w-[420px]">
        <thead><tr className="text-left text-slate-500"><th className="py-1 font-medium">Fonte</th><th className="py-1 font-medium">Campagna</th><th className="py-1 text-right font-medium">Reali</th><th className="py-1 text-right font-medium">Prova</th></tr></thead>
        <tbody>{d.rows.map((r, i) => (
          <tr key={i} className="border-t border-slate-100" data-testid={`lead-stats-row-${i}`}>
            <td className="py-1.5 text-slate-700">{r.label}{r.simulated && <span className="ml-1 rounded bg-amber-50 px-1 text-[10px] text-amber-800">simulazione</span>}</td>
            <td className="py-1.5 text-slate-500">{r.campaign || "—"}</td><td className="py-1.5 text-right font-medium">{r.real}</td><td className="py-1.5 text-right text-slate-500">{r.test}</td></tr>))}</tbody>
      </table></div>
    </section>);
}
